import { __awaiter } from "tslib";
import Vue from 'vue';
import { classToPositiveNumber } from './mixins/classToPositiveNumber';
import { mapGetters } from 'vuex';
import coinInfo from './components/coin-info/coinInfo.vue';
import coinCard from './components/coin-card/coinCard.vue';
import draggable from 'vuedraggable';
import finRes from './components/fin-res/finRes.vue';
import services from '@/services';
import _ from 'lodash';
import BASE_CONSTANTS from '@/constants/baseConstants';
const debouncedCoinOrderUpdate = _.debounce(function (orderSpotCoins, convertedCoins) {
    return __awaiter(this, void 0, void 0, function* () {
        services.v2.widgets.changeSpotSettings({ sortedCoins: orderSpotCoins, convertedCoins });
    });
}, 3000);
export default Vue.extend({
    name: 'spotWallet',
    props: {
        opened: {
            type: Boolean,
            default: false
        },
        isItOnTop: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        resetAwait: false,
        dragging: false,
        additionalAssetPanelOpen: false,
        showAdditionalAssetsLoading: false,
        finResetLoadingTotal: false,
        finResetLoadingUSDT: false,
        finResetLoadingUSDC: false,
        finResetLoadingFDUSD: false,
        additionalAssets: [],
        selectedSecondaryAsset: 'USDC'
    }),
    watch: {
        getSpotAdditionalCoins() {
            this.additionalAssets = this.getSpotAdditionalCoins;
        }
    },
    computed: Object.assign(Object.assign({}, mapGetters('mainPageModules', {
        storeState: 'getMainPageWidget',
        getSpotDeposit: 'getSpotDeposit',
        getSpotFinres: 'getSpotFinres',
        getSpotSettings: 'getSpotSettings',
        getSpotAvailableSecondaryCoins: 'getSpotAvailableSecondaryCoins',
        getUSDRates: 'getUSDRates',
        getSpotAvailableAdditionalCoins: 'getSpotAvailableAdditionalCoins',
        getSpotAdditionalCoins: 'getSpotAdditionalCoins',
        getSpotCoinsConvertedToUSD: 'getSpotCoinsConvertedToUSD',
        getFixedUSDRates: 'getFixedUSDRates'
    })), { constants() {
            return BASE_CONSTANTS;
        }, optionList() {
            return this.getSpotAvailableSecondaryCoins.map((asset) => { return { key: asset, value: asset }; });
        }, secondaryFinResultLoaderString() {
            return `finResetLoading${this.selectedSecondaryAsset}`;
        },
        secondaryFinResultLoader() {
            return this[`finResetLoading${this.selectedSecondaryAsset}`];
        }, getOrderSettingsValue() {
            const defaultOrder = ['BTC', 'ETH', 'BNB', 'XRP', 'USDC', 'FDUSD', 'TUSD'];
            const currentOrderCoins = this.additionalAssets.map((asset) => asset.name);
            const orderSpotCoins = Array.from(new Set([...currentOrderCoins, ...defaultOrder]));
            return orderSpotCoins;
        } }),
    mixins: [classToPositiveNumber],
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            this.$store.dispatch('mainPageModules/loadSpotData');
        });
    },
    methods: {
        getFinresValueByCoinName(coinName) {
            const isCoinInUSD = this.isCoinConvertedToUSD(coinName);
            const valueMultiplier = isCoinInUSD ? this.getFixedUSDRates[coinName] : 1;
            const initValue = this.getSpotFinres[coinName.toLowerCase()].value;
            return initValue.multipliedBy(valueMultiplier);
        },
        isCoinConvertedToUSD(coin) {
            return this.getSpotCoinsConvertedToUSD.includes(coin);
        },
        updateSelectedAsset(value) {
            this.selectedSecondaryAsset = value;
        },
        changeCoinFinresUSDStatus(coin) {
            const updatedConvertedUSDSettings = new Set(this.getSpotCoinsConvertedToUSD);
            const action = updatedConvertedUSDSettings.has(coin) ? 'delete' : 'add';
            updatedConvertedUSDSettings[action](coin);
            this.$store.commit('mainPageModules/setSpotCoinsConvertedToUSD', Array.from(updatedConvertedUSDSettings));
            debouncedCoinOrderUpdate([...this.getOrderSettingsValue, 'USDT'], this.getSpotCoinsConvertedToUSD);
        },
        dragEndHandler() {
            this.dragging = false;
            debouncedCoinOrderUpdate([...this.getOrderSettingsValue, 'USDT'], this.getSpotCoinsConvertedToUSD);
        },
        resetFinres(values, loader, all = false) {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm[loader] = true;
                const response = yield vm.services.v2.widgets.resetSpotFinres({ coins: values });
                vm[loader] = false;
                if (!response.success) {
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: vm.$t('mainPage.alerts.titles.error'),
                        type: 'error',
                        autoDelete: true,
                        onlyContent: true,
                        content: all ? vm.$t('mainPage.alerts.content.totalFinrezNotReset', { wallet: 'спотового' }) : vm.$t('mainPage.alerts.content.finrezNotReset', { value: values })
                    });
                    return;
                }
                vm.$store.dispatch('alertsBus/openAlert', {
                    title: vm.$t('mainPage.alerts.titles.success'),
                    type: 'success',
                    autoDelete: true,
                    onlyContent: true,
                    content: all ? vm.$t('mainPage.alerts.content.totalFinrezReset', { wallet: 'спотового' }) : vm.$t('mainPage.alerts.content.finrezReset', { value: values })
                });
                vm.$store.dispatch('mainPageModules/loadSpotData');
            });
        }
    },
    components: {
        coinInfo,
        draggable,
        coinCard,
        finRes
    }
});
